import { useContext, useEffect, useState } from 'react';
import { FindCarrierCarrierOrGroupResponseOutDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';

const useCustomerCarriersAndGroups = (): FindCarrierCarrierOrGroupResponseOutDTO[] => {
  const [carrierAndGroups, setCarrierAndGroups] = useState<FindCarrierCarrierOrGroupResponseOutDTO[]>([]);
  const { cuFindCarriersOrCarrierGroupsV2 } = useContext(ApiContext);

  useEffect(() => {
    cuFindCarriersOrCarrierGroupsV2('', data => setCarrierAndGroups(data));
  }, []);

  return carrierAndGroups;
};

export default useCustomerCarriersAndGroups;